<app-appbar></app-appbar>

<ion-content [fullscreen]="false" [scrollY]="false">
  <div
    [ngClass]="{ 'isLandscape sized-box-landscape': isLandscape() }"
    [class.isPortrait]="!isLandscape()"
    class="sized-box"
  ></div>

  <div class="heading-blur-bg">
    <div class="bg-shapes" aria-hidden="true">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
      <div class="bg-shape shape-4"></div>
      </div>
  </div>

  <div class="app-container">
    <div class="web-wrapper">
      <app-sidebar></app-sidebar>
      <div class="container-body">
        <div class="chat-layout">
          <!-- Main Content Area -->
          <div class="chat-content">
            <div class="chat-body">
              <router-outlet />
            </div>
          </div>

          <!-- Bottom Navigation Spacer (Mobile) -->
          @if(!isLandscape()) {
          <div class="chat-footer-spacer"></div>
          } @if(!isKeyboardOpen) {
          <div class="chat-footer-spacer"></div>
          }
        </div>
      </div>
    </div>
  </div>
</ion-content>

<!-- Bottom Navigation (Mobile - Fixed) -->
<div class="chat-footer-fixed">
  <app-navbar></app-navbar>
</div>
